import { get, post, put } from "../api_helper";
import * as url from "../url_helper";

const baseURL = process.env.REACT_APP_API_DOTNET_URL;

export const getUnmappedPositions = () =>
  get(`${baseURL + url.POSITION_MAPPING_BASE}/unmapped`);

export const getUnmatchedClassifications = () =>
  get(`${baseURL + url.POSITION_MAPPING_BASE}/unmatched`);

export const getPositionsWithNoClassification = () =>
  get(`${baseURL + url.POSITION_MAPPING_BASE}/no-classification`);

export const getClassificationsLookup = () =>
  get(`${baseURL + url.POSITION_MAPPING_BASE}/classifications-lookup`);

export const proposePositionMapping = (payload) =>
  post(`${baseURL + url.POSITION_MAPPING_BASE}/propose`, payload);

export const getPendingPositionMappings = () =>
  get(`${baseURL + url.POSITION_MAPPING_BASE}/pending`);

export const decidePositionMapping = (id, payload) =>
  put(`${baseURL + url.POSITION_MAPPING_BASE}/${id}/decide`, payload);

export const getPositionMappingHistory = () =>
  get(`${baseURL + url.POSITION_MAPPING_BASE}/history`);
